import { randomBytes } from 'crypto'

const url = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'

/**
 * Create unique ID by Bytes size
 */
export const nanoId = (size) => {
  size = size || 21
  var id = ''
  var bytes = randomBytes(size)
  while (size-- > 0) {
    id += url[bytes[size] & 61]
  }
  return id
}

/**
 * Convert file to base64
 */
export const toBase64 = (file) => {
  return new Promise((resolve, reject) => {
    var reader = new FileReader()
    reader.readAsBinaryString(file)
    reader.onload = () => resolve(btoa(reader.result))
    reader.onerror = err => reject(new Error(err))
  })
}

export const cleanObject = (obj) => {
  let clone = {}
  Object.keys(obj).forEach(key => {
    let value = obj[key]
    if (value === null || value === undefined) return
    let v = typeof value === 'object'
              ? Array.isArray(value)
                ? value.map(x => typeof x === 'object' ? cleanObject(x) : x)
                : cleanObject(value)
              : value
    if (v) clone[key] = v
  })
  return clone
}
